// extracted by mini-css-extract-plugin
export default {"container":"container-p8fRF","tag":"tag-ja5pC"};